import React, {useEffect} from 'react';
import {Button, Grid} from '@mui/material';
import {useForm} from 'react-hook-form';
import {useQsParams} from 'hooks';
import {Form, FormDatePicker} from 'components/form';
import {HeaderSearchAutocomplete} from 'components/shared/HeaderSearch/HeaderSearchAutocomplete';
import {departmentControllerFindAllUnique, getDepartmentControllerFindAllUniqueQueryKey} from 'api/department';
import {divisionControllerFindAll, getDivisionControllerFindAllQueryKey} from 'api/division';
import {districtControllerFindAll, getDistrictControllerFindAllQueryKey} from 'api/district';

export const RatingSearchInputs = () => {
    const form = useForm();
    const {reset, watch, setValue} = form;
    const [params, setParams] = useQsParams();
    const {date, department, division, district} = params;
    const onSubmit = (data: any) => {
        const newData = data;
        Object.keys(newData).forEach(function (key) {
            if (newData[key] && newData[key]?.other) {
                delete newData[key].other;
            }
        });
        setParams({...params, ...newData});
    };
    useEffect(() => {
        reset({
            department,
            division,
            district,
            date: Array.isArray(date) ? date?.map((el: any) => (String(new Date(el)) !== 'Invalid Date' ? new Date(el) : '')) : []
        });
    }, [params]);
    const watchDepartment = watch('department');
    const watchDivision = watch('division');
    const watchDistrict = watch('district');

    useEffect(() => {
        if (watchDepartment) {
            if (watchDepartment?.other?.districtId && !watchDistrict) {
                setValue('district', {
                    name: watchDepartment?.other?.district?.name,
                    id: watchDepartment?.other?.district?.id
                });
            }
        }
    }, [watchDepartment]);

    useEffect(() => {
        if (watchDistrict && String(watchDistrict?.id) !== String(watchDepartment?.districtId)) {
            setValue('department', undefined);
        }
    }, [watchDistrict]);


    return (
        <Form form={form} onSubmit={onSubmit}>
            <Grid container spacing={2.5}>
                <Grid item xs={12} sm={3} md={4} lg={2.75}>
                    <FormDatePicker size='small' name='date' placeholder='Выберите даты' color='secondary' />
                </Grid>
                <Grid item xs={12} sm={3} md={4} lg={2.75}>
                    <HeaderSearchAutocomplete
                        name='district'
                        optionText='name'
                        queryProps={{
                            query: districtControllerFindAll,
                            queryKey: getDistrictControllerFindAllQueryKey
                        }}
                        placeholder='Выберите округ'
                    />
                </Grid>
                <Grid item xs={12} sm={3} md={4} lg={2.75}>
                    <HeaderSearchAutocomplete
                        name='division'
                        optionText='name'
                        queryProps={{
                            query: divisionControllerFindAll,
                            queryKey: getDivisionControllerFindAllQueryKey
                        }}
                        placeholder='Выберите дивизион'
                    />
                </Grid>
                <Grid item xs={12} sm={3} md={4} lg={2.75}>
                    <HeaderSearchAutocomplete
                        name='department'
                        optionText='abbreviation'
                        queryProps={{
                            query: departmentControllerFindAllUnique,
                            queryKey: getDepartmentControllerFindAllUniqueQueryKey
                        }}
                        filter={{
                            'filter[districtId]': watchDistrict?.id,
                            'filter[divisionId]': watchDivision?.id,
                        }}
                        placeholder='Выберите подразделение'
                        additionalValues={['districtId']}
                    />
                </Grid>
                <Grid item xs={12} sm={3} md={4} lg={1}>
                    <Button
                        fullWidth
                        variant='contained'
                        color='inherit'
                        size='small'
                        type='submit'
                        sx={{
                            bgcolor: 'white',
                            color: 'text.primaryConst',
                            '&:hover': {bgcolor: 'white', color: 'text.primaryConst'}
                        }}>
                        Найти
                    </Button>
                </Grid>
            </Grid>
        </Form>
    );
};
